<template>
  <div class="content">
    <Form :model="formData" :label-width="150">
      <FormItem label="模型">
        <Input v-model="formData.model" :disabled="!isEdit" style="width: 420px"></Input>
      </FormItem>
      <FormItem label="API密钥">
        <Input v-model="formData.api_key" :disabled="!isEdit" style="width: 420px"></Input>
      </FormItem>
      <FormItem label="基础URL">
        <Input v-model="formData.base_url" :disabled="!isEdit" style="width: 420px"></Input>
      </FormItem>
      <FormItem label="提示语">
        <Input
          type="textarea"
          v-model="formData.prompt"
          :disabled="true"
          style="width: 420px"
        ></Input>
      </FormItem>
      <FormItem label="内容播报">
        <InputNumber
          v-model="formData.blockBeforeMs"
          :disabled="!isEdit"
          :min="0"
          style="width: 240px"
        />
        <span style="margin-left: 8px;">毫秒前，不允许打断</span>
      </FormItem>

      <FormItem>
        <Checkbox v-model="formData.allowOpenInterrupt" :disabled="!isEdit">
          开场白支持打断
        </Checkbox>
      </FormItem>
      <FormItem>
        <Checkbox v-model="formData.allowEndInterrupt" :disabled="!isEdit">
          结束语支持打断
        </Checkbox>
      </FormItem>
      <FormItem label="参数">
        <Row :gutter="16" style="width: 600px; margin-bottom: 6px;" v-for="(value, index) in formData.params" :key="index">
          <Col span="8">
            <Input v-model="formData.params[index].key" :disabled="!isEdit" placeholder="参数名"></Input>
          </Col>
          <Col span="6">
            <Select
              v-model="formData.params[index].type"
              :disabled="!isEdit"
            >
              <Option
                v-for="item in [{ label: '数字', value: 'NUM' }, { label: '字符串', value: 'STR' }, { label: '对象', value: 'OBJECT' }, { label: '布尔', value: 'BOOL' }]"
                :value="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </Option>
            </Select>
          </Col>
          <Col span="8">
            <!-- 根据类型渲染不同输入控件 -->
            <Input
              v-if="formData.params[index].type === 'NUM' || formData.params[index].type === 'STR'"
              v-model="formData.params[index].val"
              :disabled="!isEdit"
            />
            <Input
              type="textarea"
              v-else-if="formData.params[index].type === 'OBJECT'"
              v-model="formData.params[index].val"
              :disabled="!isEdit"
              placeholder='请输入JSON对象，如：{"a":1}'
              :autosize="{minRows: 1, maxRows: 5}"
            />
            <Select
              v-else-if="formData.params[index].type === 'BOOL'"
              v-model="formData.params[index].val"
              :disabled="!isEdit"
              style="width: 100%"
            >
              <Option :value="true" :key="'true'">true</Option>
              <Option :value="false" :key="'false'">false</Option>
            </Select>
          </Col>
          <Col span="2">
            <Icon
              class="var-del-icon"
              color="#ed4014"
              type="ios-trash-outline"
              @click="formData.params.splice(index, 1)"
            />
          </Col>
        </Row>
        <Row style="width: 582px;">
          <Col span="22">
            <Button type="dashed" long @click="addParameters" icon="md-add">添加参数</Button>
          </Col>
        </Row>
      </FormItem>
      <FormItem>
        <Button type="primary" v-show="!isEdit" @click="openEdit">编辑</Button>
        <Button type="primary" v-show="isEdit" @click="save">保存</Button>
        <Button style="margin-left: 8px" v-show="isEdit" @click="cancel">取消</Button>
      </FormItem>
    </Form>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      isEdit: false,
      formData: {
        model: '',
        api_key: '',
        base_url: '',
        prompt: '',
        blockBeforeMs: 2500,
        allowOpenInterrupt: false,
        allowEndInterrupt: false,
        params: [{ key: '', type: 'NUM', val: '' }],
      },
      params: [],
    }
  },
	computed: {
    ...mapState('setting', ['llm']),
	},
  watch: {
    llm: {
      immediate: true,
      handler(val) {
        this.resetForm()
      }
    },
  },
  methods: {
    ...mapActions('setting', ['updateLLM']),
    openEdit() {
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.resetForm();
    },
    // 添加参数
    addParameters() {
      this.formData.params.push({ key: '', type: 'NUM', val: '' });
    },
    resetForm() {
      if (this.llm && this.llm.parameters) {
        this.formData.params = Object.keys(this.llm.parameters).map(key => {
          const val = this.llm.parameters[key]
          let type = 'NUM'
          if (typeof val === 'object' && val !== null) {
            type = 'OBJECT'
          } else if (typeof val === 'boolean') {
            type = 'BOOL'
          } else if (typeof val === 'string') {
            type = 'STR'
          }
          return {
            key,
            type,
            val: type === 'OBJECT' ? JSON.stringify(val) : val
          }
        })
      }
      this.formData = { ...this.formData, ...this.llm }
    },
    save() {
      // prompt 由场景 LLM 配置页面拼接生成，这里不再参与编辑和保存
      const { params, prompt, ...formData } = this.formData
      const parameters = params.filter(item => !!item.key && !!item.type).reduce((item, next) => {
        if (next.type === 'NUM') {
          item[next.key] = Number(next.val)
        } else if (next.type === 'OBJECT') {
          try {
            item[next.key] = typeof next.val === 'string' ? JSON.parse(next.val) : next.val
          } catch (e) {
            this.$Message.warning(`参数 ${next.key} 对象格式不正确，请输入合法JSON`)
            throw e
          }
        } else if (next.type === 'BOOL') {
          if (next.val === 'true' || next.val === true) {
            item[next.key] = true
          } else if (next.val === 'false' || next.val === false) {
            item[next.key] = false
          } else {
            item[next.key] = Boolean(next.val)
          }
        } else {
          item[next.key] = next.val
        }
        return item
      }, {})
      this.updateLLM({
        ...formData,
        parameters
      });
      this.isEdit = false;
    },
    createParams(val) {
      this.params.push({
        value: val,
        label: val
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 15px;
}
</style>
